module.exports = __webpack_public_path__ + "img/logo.ac4ad641.png";